import { useTranslation } from "react-i18next";

export function useChatSteps() {
  const { t } = useTranslation("tours");
  return [
    {
      target: '[data-testid="chat-sidebar"]',
      title: t("chat.step1.title"),
      content: t("chat.step1.content"),
    },
    {
      target: '[data-testid="chat-new-session"]',
      title: t("chat.step2.title"),
      content: t("chat.step2.content"),
    },
    {
      target: '[data-testid="chat-main"]',
      title: t("chat.step3.title"),
      content: t("chat.step3.content"),
    },
  ];
}
